import { Box, Card, Divider, Typography } from "@mui/material";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { MarketResearchStudy } from "../models";
import useMarketResearchStore from "../useMarketResearchStore";
import { StudyIcon } from "./StudyIcon";

interface StudyTileProps {
  study: MarketResearchStudy;
}

export default function StudyTile({ study }: StudyTileProps) {
  const { safeParseCreatedTs, isWithinLast3Weeks, navigate, setTherapeuticArea } = useMarketResearchStore();
  const studyPath = `/market-research/study/${study.study_guid}`;
  const created = safeParseCreatedTs(study.created_ts);
  const showRecentlyAdded = created !== undefined && isWithinLast3Weeks(created);

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Link
        to={studyPath}
        style={{ textDecoration: "none", display: "block", height: "100%" }}
        onClick={(e) => {
          e.preventDefault();
          setTherapeuticArea(study.therapeutic_area);
          navigate(studyPath);
        }}
      >
        <Card
          sx={{
            borderRadius: "28px",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            position: "relative",
            height: "100%",
            minHeight: "220px",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.05)",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "20px" }}>
            {showRecentlyAdded && (
              <Box
                sx={{
                  background: "#AF1685",
                  position: "absolute",
                  height: "24px",
                  left: 0,
                  top: 0,
                  width: "125px",
                  justifyContent: "center",
                  alignItems: "center",
                  borderBottomRightRadius: "12px",
                  display: "flex",
                }}
              >
                <Typography variant="h6" sx={{ color: "white", fontSize: "10px", fontWeight: "700" }}>
                  RECENTLY ADDED
                </Typography>
              </Box>
            )}

            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem", mt: "1rem" }}>
              <Typography
                variant="h5"
                sx={{ fontSize: "24px", height: "4rem", overflow: "hidden" }}
                title={study.study_title}
              >
                {study.study_title}
              </Typography>
              <Divider />
              <Box sx={{ display: "flex", gap: "0.8rem" }} alignItems={"center"}>
                <StudyIcon therapeuticArea={study.therapeutic_area} />
                <Box sx={{ display: "flex", gap: "0.5rem", flexDirection: "column" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.2rem",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="h6" sx={{ fontSize: "10px", color: " rgba(66, 84, 102, 0.6)" }}>
                      FIELDED
                    </Typography>
                    <Typography variant="h6" sx={{ fontSize: "13px", color: "#004677", textWrap: "nowrap" }}>
                      {dayjs(study.study_date).format("MMMM D, YYYY")}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      padding: "0.3rem",
                      backgroundColor: "#00A3E0",
                      borderRadius: "10px",
                      justifyContent: "center",
                      display: study.num_respondents ? "flex" : "none",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h6" sx={{ fontSize: "13px", color: "white" }}>
                      {study.num_respondents} respondents
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Card>
      </Link>
    </Box>
  );
}
